










































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import TitleRepository from "@/repositories/request/TitleRepository";
import { Title } from "@/modules/request/Title";
import _ from "lodash";

const components = {
};

@Component({ components })
export default class AdminTitle extends Vue {
    private newTitle: string = "";
    private modalTitleVisible: boolean = false;
    private titleUuid: string = "";

    private title: Title = {
        uuid: null,
        label: "",
        owner: {
            uuid: ""
        }
    };

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getTitles") public titles!: () => Title[];

    @Watch("ownerUuid") private updateOwner() {
        this.title.owner.uuid = this.ownerUuid;
    }

    public mounted(): void {
        this.title.owner.uuid = this.ownerUuid;
    }

    private addTitle(): void {
        this.title.label = "";
        this.title.uuid = null;
        this.modalTitleVisible = true;
    }

    private saveTitle(): void {
        TitleRepository.save(this.title).then(() => {
            this.$store.dispatch("loadTitles");
            this.modalTitleVisible = false;
            this.newTitle = "";
        });
    }

    private editTitle(title: Title): void {
        this.modalTitleVisible = true;
        this.title.uuid = title.uuid;
        this.title.label = title.label;
    }

    private cancelEditTitle(): void {
        this.newTitle = "";
        this.titleUuid = "";
        this.modalTitleVisible = false;
    }

    private deleteTitle(titleUuid: string): void {
        this.$confirm(_.invoke(this.$options.filters, "trans", "deleteTitleConfirmation"))
            .then(() => {
                TitleRepository.delete({ uuid: titleUuid }).then(() => {
                    this.$store.dispatch("loadTitles");
                });
            })
            .catch(() => 0)
        ;
    }
}
